import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";


@Injectable({
  providedIn: "root"
})
export class LoginService {
  private login = new BehaviorSubject<string>("");
  currentStatus = this.login.asObservable();

  constructor(private http: HttpClient) {}

  checkAuthentication(isLogin: string) {
    this.login.next(isLogin);
  }
}
